class ProductCardSlider extends HTMLElement {
  constructor() {
    super()

    this.slides = Array.from(this.querySelectorAll('.product-card-slider__item'))
    this.currentIndex = 0
    this.sliderContainer = null
    this.paginationContainer = null
    this.isDesktop = window.matchMedia('(min-width: 1024px)').matches

    this.isMobileDisabled = this.hasAttribute('data-mobile-disabled')

    if (this.slides.length > 1) {
      this.initSlider()
    }
  }

  initSlider() {
    this.classList.add('product-card-slider')

    this.sliderContainer = document.createElement('div')
    this.sliderContainer.classList.add('slider-container')

    this.slides.forEach((slideContent) => {
      const slide = document.createElement('div')
      slide.classList.add('slider-slide')

      const spinner = document.createElement('div')
      spinner.classList.add('slide-spinner')
      slide.appendChild(spinner)

      const img = slideContent.querySelector('img')
      if (img.complete) {
        spinner.style.display = 'none'
      } else {
        img.addEventListener(
          'load',
          () => {
            spinner.style.display = 'none'
          },
          { once: true }
        )
        img.addEventListener(
          'error',
          () => {
            spinner.style.display = 'none'
          },
          { once: true }
        )
      }

      slide.appendChild(slideContent)
      this.sliderContainer.appendChild(slide)
    })

    this.appendChild(this.sliderContainer)
    this.createPagination()

    // Initialiser le comportement selon le device
    this.updateBehavior()
  }

  updateBehavior() {
    if (this.isDesktop) {
      this.classList.add('desktop-mode')
    } else {
      this.classList.remove('desktop-mode')
      if (!this.isMobileDisabled) {
        this.initPaginationObserver()
      } else if (this.sliderContainer) {
        this.currentIndex = 0
        this.sliderContainer.scrollTo({ left: 0 })
      }
    }
  }

  initPaginationObserver() {
    const slides = Array.from(this.sliderContainer.querySelectorAll('.slider-slide'))
    slides.forEach((slide, index) => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.currentIndex = index
            this.updatePagination()
          }
        },
        { root: this.sliderContainer, threshold: 0.5 }
      )
      observer.observe(slide)
    })
  }

  createPagination() {
    this.paginationContainer = document.createElement('div')
    this.paginationContainer.classList.add('slider-pagination')

    this.slides.forEach((_, index) => {
      const dot = document.createElement('span')
      dot.classList.add('slider-pagination__dot')
      if (index === 0) {
        dot.classList.add('active')
      }
      dot.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.showSlide(index)
      })
      this.paginationContainer.appendChild(dot)
    })

    this.appendChild(this.paginationContainer)
  }

  updatePagination() {
    const dots = this.paginationContainer.querySelectorAll('.slider-pagination__dot')
    dots.forEach((dot, i) => {
      if (i === this.currentIndex) {
        dot.classList.add('active')
      } else {
        dot.classList.remove('active')
      }
    })
  }

  showSlide(index, instant = false) {
    const numSlides = this.slides.length
    if (index >= numSlides) {
      this.currentIndex = 0
    } else if (index < 0) {
      this.currentIndex = numSlides - 1
    } else {
      this.currentIndex = index
    }

    if (this.sliderContainer) {
      const slideWidth = this.sliderContainer.offsetWidth
      this.sliderContainer.scrollTo({
        left: this.currentIndex * slideWidth,
        behavior: instant ? 'auto' : 'smooth'
      })
    }

    this.updatePagination()
  }
}

customElements.get('product-card-slider') || customElements.define('product-card-slider', ProductCardSlider)

function setupCountryList() {
  const countryList = document.getElementById('CountryList')
  if (!countryList) return

  // Initial backup of the original list items
  if (!countryList.dataset.initialHtml) {
    countryList.dataset.initialHtml = countryList.innerHTML
  }

  const countryListItems = Array.from(
    new DOMParser().parseFromString(countryList.dataset.initialHtml, 'text/html').querySelectorAll('li')
  )

  const americasCode = ['US', 'CA', 'MX', 'BR', 'AR', 'CL', 'CO', 'PA', 'CR']
  const asiaCode = ['AU', 'JP', 'KR', 'CN', 'HK', 'MO', 'TW', 'SG', 'MY']
  const middleEastCode = ['AE', 'BH', 'OM', 'QA', 'KW', 'SA', 'IL', 'JO', 'LB']
  const europeCode = [
    'FR',
    'DE',
    'IT',
    'ES',
    'GB',
    'NL',
    'BE',
    'AT',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'GR',
    'HU',
    'IS',
    'IE',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'NO',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'SE',
    'CH',
    'MC',
    'AD',
    'ME',
    'AL'
  ]
  const africaCode = ['MU']

  const americas = []
  const asia = []
  const middleEast = []
  const europe = []
  const africa = []
  const other = []

  countryListItems.forEach((country) => {
    const continentOption = country.querySelector('[data-option]')
    if (!continentOption) {
      return
    }
    const continent = continentOption.dataset.option
    if (!continent) {
      return
    }
    if (americasCode.includes(continent)) {
      americas.push(country)
    } else if (asiaCode.includes(continent)) {
      asia.push(country)
    } else if (middleEastCode.includes(continent)) {
      middleEast.push(country)
    } else if (europeCode.includes(continent)) {
      europe.push(country)
    } else if (africaCode.includes(continent)) {
      africa.push(country)
    } else {
      other.push(country)
    }
  })

  const sortByName = (a, b) => {
    const nameA = a.innerText.trim()
    const nameB = b.innerText.trim()
    return nameA.localeCompare(nameB, 'fr', { sensitivity: 'base' })
  }

  americas.sort(sortByName)
  asia.sort(sortByName)
  middleEast.sort(sortByName)
  europe.sort(sortByName)
  africa.sort(sortByName)
  other.sort(sortByName)

  function getNumberOfColumns() {
    const width = window.innerWidth
    if (width >= 1600) {
      return 4
    }
    if (width >= 1200) {
      return 3
    }
    return 2
  }

  function reorderForColumns(list, cols) {
    if (cols <= 1) {
      return list
    }
    const reordered = []
    const baseNumRows = Math.floor(list.length / cols)
    const extraItems = list.length % cols
    const columns = []

    let startIndex = 0
    for (let c = 0; c < cols; c++) {
      const numRows = baseNumRows + (c < extraItems ? 1 : 0)
      columns.push(list.slice(startIndex, startIndex + numRows))
      startIndex += numRows
    }

    const maxRows = columns[0] ? columns[0].length : 0
    for (let r = 0; r < maxRows; r++) {
      for (let c = 0; c < cols; c++) {
        if (columns[c] && columns[c][r]) {
          reordered.push(columns[c][r])
        }
      }
    }

    return reordered
  }

  // Réorganiser asia pour placer HK, MO, TW juste après CN
  const chinaCodes = ['CN', 'HK', 'MO', 'TW']
  const chinaRegions = []
  let cnIndex = -1

  // Trouver CN et extraire HK, MO, TW
  asia.forEach((li, index) => {
    const el = li.querySelector('[data-option]')
    const code = el && el.dataset.option
    if (code === 'CN') {
      cnIndex = index
    } else if (code && chinaCodes.includes(code)) {
      chinaRegions.push({ item: li, code: code })
    }
  })

  // Retirer HK, MO, TW de la liste
  chinaRegions.forEach((region) => {
    const idx = asia.indexOf(region.item)
    if (idx > -1) {
      asia.splice(idx, 1)
      if (idx < cnIndex) {
        cnIndex--
      }
    }
  })

  // Trier les régions chinoises : HK, MO, TW
  const regionOrder = { HK: 0, MO: 1, TW: 2 }
  chinaRegions.sort((a, b) => regionOrder[a.code] - regionOrder[b.code])

  // Insérer HK, MO, TW juste après CN
  if (cnIndex > -1 && chinaRegions.length > 0) {
    chinaRegions.forEach((region, i) => {
      asia.splice(cnIndex + 1 + i, 0, region.item)
    })
  }

  const numCols = getNumberOfColumns()

  const reorderedAmericas = reorderForColumns(americas, numCols)
  const reorderedAsia = reorderForColumns(asia, numCols)
  const reorderedMiddleEast = reorderForColumns(middleEast, numCols)
  const reorderedEurope = reorderForColumns(europe, numCols)
  const reorderedAfrica = reorderForColumns(africa, numCols)
  const reorderedOther = reorderForColumns(other, numCols)

  countryList.innerHTML = ''

  if (africa.length > 0) {
    let blockHTML = `<li class="continent-group africa-group">`
    blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.africa}</div>`
    blockHTML += `<ul class="countries-sublist">`
    reorderedAfrica.forEach((countryName) => {
      blockHTML += countryName.outerHTML
    })
    blockHTML += `</ul>`
    blockHTML += `</li>`
    countryList.innerHTML += blockHTML
  }

  if (americas.length > 0) {
    let blockHTML = `<li class="continent-group americas-group">`
    blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.america}</div>`
    blockHTML += `<ul class="countries-sublist">`
    reorderedAmericas.forEach((countryName) => {
      blockHTML += countryName.outerHTML
    })
    blockHTML += `</ul>`
    blockHTML += `</li>`
    countryList.innerHTML += blockHTML
  }

  if (asia.length > 0) {
    let blockHTML = `<li class="continent-group asia-group">`
    blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.asia}</div>`
    blockHTML += `<ul class="countries-sublist">`

    // Détection de la langue actuelle
    const currentLang = document.documentElement.lang || 'en'
    const isFrench = currentLang.startsWith('fr')
    const isJapanese = currentLang.startsWith('ja')

    // Render tous les pays d'Asie
    reorderedAsia.forEach((countryItem) => {
      const html = countryItem.outerHTML
      const match = html.match(/data-option="([A-Z]{2})"/)
      const code = match && match[1]

      // CN : FR => Chine (continentale) & EN => China (Mainland)
      if (code === 'CN') {
        let modifiedHtml = html
        const textMatch = modifiedHtml.match(/<span class="text-left inline[^>]*>([^<]+)<\/span>/)
        const countryText = textMatch ? textMatch[1] : ''
        let finalCountryText = countryText

        finalCountryText = window.localizationStrings.chinaMainland

        modifiedHtml = modifiedHtml.replace(
          /<span class="text-left inline[^>]*>([^<]+)<\/span>/,
          `<span class="btn btn-link !p-0 min-h-fit leading-[16px] inline">${finalCountryText}</span>`
        )

        blockHTML += modifiedHtml
      }
      // HK, MO, TW : appliquer les transformations
      else if (code && ['CN', 'HK', 'MO', 'TW'].includes(code)) {
        let modifiedHtml = html

        // Extraire le texte du pays
        const textMatch = modifiedHtml.match(/<span class="text-left inline[^>]*>([^<]+)<\/span>/)
        const countryText = textMatch ? textMatch[1] : ''
        let finalCountryText = countryText

        // Japonais : texte fixe pour HK, MO, TW
        if (isJapanese) {
          if (code === 'HK') finalCountryText = '香港特別行政区'
          else if (code === 'MO') finalCountryText = 'マカオ特別行政区'
          else if (code === 'TW') finalCountryText = '台湾地区'
        }
        // En français pour HK et MO : Remplacer SAR par RAS et retirer 'chinoise'
        else if (isFrench && (code === 'HK' || code === 'MO')) {
          finalCountryText = finalCountryText.replace(/\bR\.A\.S\./g, 'RAS').replace(/\bchinoise\b/g, '')
        }
        // Pour Taiwan : Région de Taïwan (en français) ou Region of Taiwan (en anglais)
        else if (code === 'TW') {
          if (isFrench) {
            finalCountryText = finalCountryText.replace(/(Ta[ïi]wan)/g, 'Région de $1')
          } else {
            finalCountryText = finalCountryText.replace(/(Taiwan)/g, '$1 Region')
          }
        }

        // Ajouter le marker noir avant le texte
        const blackDot = '<span>&nbsp;•&nbsp;&nbsp;</span>'
        const wrappedText = `<span class="btn btn-link !p-0 min-h-fit leading-[16px] inline">${finalCountryText}</span>`
        modifiedHtml = modifiedHtml.replace(
          /<span class="text-left inline btn btn-link[^>]*>[^<]+<\/span>/,
          blackDot + wrappedText
        )

        blockHTML += modifiedHtml
      }
      // Autres pays : affichage normal
      else {
        blockHTML += html
      }
    })

    blockHTML += `</ul>`
    blockHTML += `</li>`
    countryList.innerHTML += blockHTML
  }

  if (europe.length > 0) {
    let blockHTML = `<li class="continent-group europe-group">`
    blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.europe}</div>`
    blockHTML += `<ul class="countries-sublist">`
    reorderedEurope.forEach((countryName) => {
      blockHTML += countryName.outerHTML
    })
    blockHTML += `</ul>`
    blockHTML += `</li>`
    countryList.innerHTML += blockHTML
  }

  if (middleEast.length > 0) {
    let blockHTML = `<li class="continent-group middle-east-group">`
    blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.middleEast}</div>`
    blockHTML += `<ul class="countries-sublist">`
    reorderedMiddleEast.forEach((countryName) => {
      blockHTML += countryName.outerHTML
    })
    blockHTML += `</ul>`
    blockHTML += `</li>`
    countryList.innerHTML += blockHTML
  }

  if (other.length > 0) {
    let blockHTML = `<li class="continent-group other-group">`
    blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.other}</div>`
    blockHTML += `<ul class="countries-sublist">`
    reorderedOther.forEach((countryName) => {
      blockHTML += countryName.outerHTML
    })
    blockHTML += `</ul>`
    blockHTML += `</li>`
    countryList.innerHTML += blockHTML
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setupCountryList()
  window.addEventListener('resize', setupCountryList)
})

class SizeGuideTabs extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('[data-size-guide-btn]')
    this.tabs = this.querySelectorAll('[data-size-guide-tab-item]')

    if (!this.buttons?.length > 0 || !this.tabs?.length > 0) return

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.handleButtonClick(button))
    })
  }

  disconnectedCallback() {
    this.buttons?.forEach((button) => {
      button.removeEventListener('click', () => this.handleButtonClick(button))
    })
  }

  handleButtonClick(button) {
    this.buttons.forEach((button) => button.classList.remove('active'))
    button.classList.add('active')

    this.tabs.forEach((tab) => {
      if (tab.dataset.sizeGuideTab === button.dataset.sizeGuideTab) {
        tab.classList.add('active')
      } else {
        tab.classList.remove('active')
      }
    })
  }
}

customElements.get('size-guide-tabs') || customElements.define('size-guide-tabs', SizeGuideTabs)
